var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": _vm.paperTitle,
      "subTitleText": 'Our Cyber Advisors have subject matter expertise across the cybersecurity spectrum. Our white papers provide deep dive views and in-depth analysis of various critical cyber topics. Please check out our technical assessments of key cybersecurity issues that will better inform you as you seek to protect your organization from cyber threats.',
      "subTitleTextMdLgXlWidth": '70%',
      "subTitleTextSmXsWidth": '75%'
    }
  })], 1)], 1), _c('section', {
    staticClass: "section p-0 mt-5 section-content"
  }, [_c('div', {
    staticClass: "container-fluid px-xs-1 px-md-5 px-lg-5"
  }, [_vm._m(0), _c('div', {
    staticClass: "mb-5"
  }, [_c('SearchControlWidget', {
    attrs: {
      "inputTextPlaceholder": 'Enter paper title here',
      "searchControlHeight": '100px',
      "searchControlWidth": '100%',
      "searchQueryInputHandler": _vm.updateSearchQuery
    }
  })], 1), _c('div', {
    staticClass: "blog-post-grid row mb-4"
  }, _vm._l(_vm.displayeditems, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "col-12 col-md-6 col-lg-4 col-xl-4 mb-2"
    }, [_c('div', {
      staticClass: "blog-item blog-grid-item h-100"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": item.imageURL,
        "alt": item.photoDescription
      }
    }), _c('div', {
      staticClass: "blog-post-info"
    }, [_c('h4', {
      staticClass: "blog-post-title limit-lines-2"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('div', {
      staticClass: "d-flex align-items-center pb-2"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isRecentDate(item.date),
        expression: "isRecentDate(item.date)"
      }],
      staticClass: "blog-info-meta text-dark text-start"
    }, [_vm._v(" " + _vm._s(_vm.getFormattedDate(item.date)) + " ")])]), _c('p', {
      staticClass: "limit-lines-5"
    }, [_vm._v(_vm._s(item.headLine))]), _c('div', {
      staticClass: "post-event-links d-flex align-items-center"
    }, [_c('a', {
      attrs: {
        "href": item.whitepaperLink,
        "variant": "link",
        "target": "_blank"
      }
    }, [_vm._v("View White Paper")])])])])]);
  }), 0), _vm.totalRows > 0 && _vm.totalRows > _vm.perPage ? _c('div', {
    staticClass: "mb-5"
  }, [_c('b-pagination', {
    staticClass: "ml-0",
    attrs: {
      "id": "blog-pagination",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    on: {
      "page-click": _vm.pageClicked
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e(), _vm.displayeditems.length === 0 ? _c('div', {
    staticClass: "row m-0 w-100 mb-4",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "col-12 p-0 d-flex justify-content-center align-items-center empty-blog-message text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.whitePaperItems.length === 0 ? `There are no papers available within the last six months` : `There are no research papers available for the search: 
            <br>
            &quot${_vm.searchQuery}&quot
            `)
    }
  })]) : _vm._e(), _vm.isRecentPapers ? _c('div', {
    staticClass: "d-flex flex-row justify-content-center mb-5"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "240"
    },
    on: {
      "click": _vm.goToWhitePaperArchives
    }
  }, [_vm._v(" View White Paper Archives ")])], 1) : _c('div', {
    staticClass: "d-flex flex-row justify-content-center mb-5"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "240"
    },
    on: {
      "click": _vm.gotToRecentPapers
    }
  }, [_vm._v(" Back To Recent ")])], 1)])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 d-flex justify-content-center section-title"
  }, [_c('span', [_vm._v("READ OUR RESEARCH")])]);

}]

export { render, staticRenderFns }